import React, { ReactNode } from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import PaginatorCst from "@components/PaginatorCst";
import SearchBar from "@components/SearchableMultiSelectListCst/SearchBar";

interface EnrollmentListShellProps {
  search: string;
  onSearchSubmit: (value: string) => void;
  searchPlaceholder?: string;
  searchButtonLabel?: string;
  filtersSlot?: ReactNode;
  headerSlot?: ReactNode;
  isLoading: boolean;
  isEmpty: boolean;
  emptyLabel: string;
  children: ReactNode;
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  onPageChange: (next: number) => void;
}

const EnrollmentListShell: React.FC<EnrollmentListShellProps> = ({
  search,
  onSearchSubmit,
  searchPlaceholder = "Cerca",
  searchButtonLabel = "Cerca",
  filtersSlot,
  headerSlot,
  isLoading,
  isEmpty,
  emptyLabel,
  children,
  page,
  pageSize,
  totalItems,
  totalPages,
  onPageChange,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SearchBar
        initialValue={search}
        onSubmit={onSearchSubmit}
        placeholder={searchPlaceholder}
        buttonLabel={searchButtonLabel}
        filtersSlot={filtersSlot}
      />

      {headerSlot}

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      ) : isEmpty ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 6,
            color: theme.palette.text.tertiary,
            fontSize: "13px",
          }}
        >
          <Typography>{emptyLabel}</Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            maxHeight: 480,
            overflowY: "auto",
          }}
        >
          {children}
        </Box>
      )}

      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <PaginatorCst
            page={page}
            pageSize={pageSize}
            totalItems={totalItems}
            onPageChange={onPageChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default EnrollmentListShell;
